module.exports = __webpack_public_path__ + "img/homework-jg.99a55992.png";